// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Customer, {getDefaultState as getCustomerDefaultState} from './customer';
import PipCode, {getDefaultState as getPipCodeDefaultState} from './pip-code';
import PipCodeType, {getDefaultState as getPipCodeTypeDefaultState} from './pip-code-type';
import PipProduct, {getDefaultState as getPipProductDefaultState} from './pip-product';
import t from 'tcomb';

const PipCodeState = t.struct({
    busyCounter: BusyCounter,
    customer: Customer,
    isFormValid: t.Boolean,
    isFormVisible: t.Boolean,
    pipCode: PipCode,
    pipCodeType: PipCodeType,
    pipProduct: PipProduct
}, 'PipCodeState');

export const getDefaultState = () =>
    new PipCodeState({
        busyCounter: getBusyCounterDefaultState(),
        customer: getCustomerDefaultState(),
        isFormValid: false,
        isFormVisible: false,
        pipCode: getPipCodeDefaultState(),
        pipCodeType: getPipCodeTypeDefaultState(),
        pipProduct: getPipProductDefaultState()
    });

export default PipCodeState;



// WEBPACK FOOTER //
// ./src/pip/pip-code/state/index.js